import projection from '../generated/pwd201f1.json';
import { AcceptanceManifest } from '../types';

export const pwd201f1AcceptanceManifest = projection as AcceptanceManifest;
